/**
 * Where a stay type's 3D miniature lives, with a version on the URL.
 *
 * The site serves /images with a 30-day browser cache, so replacing a file in
 * place is invisible to anyone who has visited in the last month: the owner
 * saw the old riad and hotel on 2026-09-26 while the server already sent the
 * new ones. Bump ICON_VERSION whenever these PNGs are redrawn.
 */
export const STAY_ICON_VERSION = "2026-09-26";

export function stayTypeIconSrc(type: string): string {
  return `/images/subcategories/stay-${type}.png?v=${STAY_ICON_VERSION}`;
}
